<template>
    <body>
    <div class="main_top" style="border-bottom:none;">
      <h1>
         <img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
        트로피 <span id="my_trophy">{{ my }}</span><span style="font-weight:normal; color:#9EA3AB">/45</span>
      </h1>
    </div>
    <div class="myPost_wrapper" style="padding:0">
      <!-- title -->
      <div class="div_padding" style="height:55px;"></div>
      <div class="trophy">
        <p>
          트로피는 컨텐츠 중 지정된 활동을 완수하면 획득 가능하며,<br>
          트로피 랭커를 대상으로 다양한 프로모션을 진행할 예정입니다.<br>
          남들이 획득 못한 레어한 트로피를 수집해보세요!
        </p>

        <div class="trophy_list">
          <!-- 트로피 -->
          <div class="">
            <div class="tro_img">
              <img src="images/basic/trophy/01.svg" alt="">
            </div>
            <p>오늘부터 1일</p>
            <span>회원가입 완료</span>
            <span>99.5%</span>
          </div>

          <!-- 트로피 -->
          <div class="">
            <div class="tro_img">
              <img src="images/basic/trophy/02.svg" alt="">
            </div>
            <p>럭앤리치</p>
            <span>슬롯머신에서 잭팟획득</span>
            <span>0.056%</span>
          </div>

          <!-- 트로피 -->
          <div class="">
            <div class="tro_img">
              <img src="images/basic/trophy/03.svg" alt="">
            </div>
            <p>수능 400점</p>
            <span>코인+-를 모두 맞춤</span>
            <span>12.92%</span>
          </div>

        </div>
      </div>
    </div>
  </body>
</template>

<script>
export default {
  data() {
    return {
      my: '9'
    }
  },

}
</script>

<style>

</style>